import { styled } from '@mui/material/styles'

export const Escrito = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(3),
  padding: theme.spacing(3.25, 2),
  borderRadius: '8px',
  border: `1px solid ${theme.colors.gray600}`
}))
